import type { JpClassApi } from "../../api/JpClassApi";
import type { ClassLocationFetchOptions } from "../../generated/dto/ClassLocationFetchOptions";
import type { ClassLocationStaff } from "../../generated/dto/ClassLocationStaff";
import type { CreateJpClass } from "../../generated/dto/CreateJpClass";
import type { CreateJpClassAttendance } from "../../generated/dto/CreateJpClassAttendance";
import type { CreateJpClassSession } from "../../generated/dto/CreateJpClassSession";
import type { CreateJpClassSignup } from "../../generated/dto/CreateJpClassSignup";
import type { CreateJpClassStagger } from "../../generated/dto/CreateJpClassStagger";
import type { CreateJpClassType } from "../../generated/dto/CreateJpClassType";
import type { CreateJpClassTypeOverride } from "../../generated/dto/CreateJpClassTypeOverride";
import type { CreateJpClassWlResult } from "../../generated/dto/CreateJpClassWlResult";
import type { DeleteJpClassAttendanceStaff } from "../../generated/dto/DeleteJpClassAttendanceStaff";
import type { DeleteJpClassSessionStaff } from "../../generated/dto/DeleteJpClassSessionStaff";
import type { DeleteJpClassSignupStaff } from "../../generated/dto/DeleteJpClassSignupStaff";
import type { DeleteJpClassStaff } from "../../generated/dto/DeleteJpClassStaff";
import type { DeleteJpClassStaggerStaff } from "../../generated/dto/DeleteJpClassStaggerStaff";
import type { DeleteJpClassTypeOverrideStaff } from "../../generated/dto/DeleteJpClassTypeOverrideStaff";
import type { DeleteJpClassTypeStaff } from "../../generated/dto/DeleteJpClassTypeStaff";
import type { DeleteJpClassWlResultStaff } from "../../generated/dto/DeleteJpClassWlResultStaff";
import type { JpClassAttendanceFetchOptions } from "../../generated/dto/JpClassAttendanceFetchOptions";
import type { JpClassAttendanceStaff } from "../../generated/dto/JpClassAttendanceStaff";
import type { JpClassFetchOptions } from "../../generated/dto/JpClassFetchOptions";
import type { JpClassMember } from "../../generated/dto/JpClassMember";
import type { JpClassRef } from "../../generated/dto/JpClassRef";
import type { JpClassSearchParams } from "../../generated/dto/JpClassSearchParams";
import type { JpClassSessionFetchOptions } from "../../generated/dto/JpClassSessionFetchOptions";
import type { JpClassSessionStaff } from "../../generated/dto/JpClassSessionStaff";
import type { JpClassSignupFetchOptions } from "../../generated/dto/JpClassSignupFetchOptions";
import type { JpClassSignupStaff } from "../../generated/dto/JpClassSignupStaff";
import type { JpClassStaff } from "../../generated/dto/JpClassStaff";
import type { JpClassStaffSearchResult } from "../../generated/dto/JpClassStaffSearchResult";
import type { JpClassStaggerFetchOptions } from "../../generated/dto/JpClassStaggerFetchOptions";
import type { JpClassStaggerStaff } from "../../generated/dto/JpClassStaggerStaff";
import type { JpClassTypeFetchOptions } from "../../generated/dto/JpClassTypeFetchOptions";
import type { JpClassTypeOverrideFetchOptions } from "../../generated/dto/JpClassTypeOverrideFetchOptions";
import type { JpClassTypeOverrideStaff } from "../../generated/dto/JpClassTypeOverrideStaff";
import type { JpClassTypeSearchParams } from "../../generated/dto/JpClassTypeSearchParams";
import type { JpClassTypeStaff } from "../../generated/dto/JpClassTypeStaff";
import type { JpClassTypeStaffSearchResult } from "../../generated/dto/JpClassTypeStaffSearchResult";
import type { JpClassWlResultFetchOptions } from "../../generated/dto/JpClassWlResultFetchOptions";
import type { JpClassWlResultStaff } from "../../generated/dto/JpClassWlResultStaff";
import type { PersonFetchOptions } from "../../generated/dto/PersonFetchOptions";
import type { PersonStaff } from "../../generated/dto/PersonStaff";
import type { RatingFetchOptions } from "../../generated/dto/RatingFetchOptions";
import type { RatingStaff } from "../../generated/dto/RatingStaff";
import type { UpdateJpClass } from "../../generated/dto/UpdateJpClass";
import type { UpdateJpClassAttendance } from "../../generated/dto/UpdateJpClassAttendance";
import type { UpdateJpClassSession } from "../../generated/dto/UpdateJpClassSession";
import type { UpdateJpClassSignup } from "../../generated/dto/UpdateJpClassSignup";
import type { UpdateJpClassStagger } from "../../generated/dto/UpdateJpClassStagger";
import type { UpdateJpClassType } from "../../generated/dto/UpdateJpClassType";
import type { UpdateJpClassTypeOverride } from "../../generated/dto/UpdateJpClassTypeOverride";
import type { UpdateJpClassWlResult } from "../../generated/dto/UpdateJpClassWlResult";
import type { PaginationResult } from "../../generated/dto/PaginationResult";

export class JpClassFrontendService {
  constructor(private readonly api: JpClassApi) {}
  async getJpClassTypeStaff(id: number, options?: JpClassTypeFetchOptions): Promise<JpClassTypeStaff> {
    return this.api.getJpClassTypeStaff(id, options)
  }
  async getJpClassTypeOverrideStaff(id: number, options?: JpClassTypeOverrideFetchOptions): Promise<JpClassTypeOverrideStaff> {
    return this.api.getJpClassTypeOverrideStaff(id, options)
  }
  async getJpClassStaff(id: number, options?: JpClassFetchOptions): Promise<JpClassStaff> {
    return this.api.getJpClassStaff(id, options)
  }
  async getJpClassSessionStaff(id: number, options?: JpClassSessionFetchOptions): Promise<JpClassSessionStaff> {
    return this.api.getJpClassSessionStaff(id, options)
  }
  async getJpClassStaggerStaff(id: number, options?: JpClassStaggerFetchOptions): Promise<JpClassStaggerStaff> {
    return this.api.getJpClassStaggerStaff(id, options)
  }
  async getJpClassSignupStaff(id: number, options?: JpClassSignupFetchOptions): Promise<JpClassSignupStaff> {
    return this.api.getJpClassSignupStaff(id, options)
  }
  async getJpClassAttendanceStaff(id: number, options?: JpClassAttendanceFetchOptions): Promise<JpClassAttendanceStaff> {
    return this.api.getJpClassAttendanceStaff(id, options)
  }
  async getJpClassWlResultStaff(id: number, options?: JpClassWlResultFetchOptions): Promise<JpClassWlResultStaff> {
    return this.api.getJpClassWlResultStaff(id, options)
  }
  async createJpClassTypeStaff(source: CreateJpClassType): Promise<JpClassTypeStaff> {
    return this.api.createJpClassTypeStaff(source)
  }
  async createJpClassTypeOverrideStaff(source: CreateJpClassTypeOverride): Promise<JpClassTypeOverrideStaff> {
    return this.api.createJpClassTypeOverrideStaff(source)
  }
  async createJpClassStaff(source: CreateJpClass): Promise<JpClassStaff> {
    return this.api.createJpClassStaff(source)
  }
  async createJpClassSessionStaff(source: CreateJpClassSession): Promise<JpClassSessionStaff> {
    return this.api.createJpClassSessionStaff(source)
  }
  async createJpClassStaggerStaff(source: CreateJpClassStagger): Promise<JpClassStaggerStaff> {
    return this.api.createJpClassStaggerStaff(source)
  }
  async createJpClassSignupStaff(source: CreateJpClassSignup): Promise<JpClassSignupStaff> {
    return this.api.createJpClassSignupStaff(source)
  }
  async createJpClassAttendanceStaff(source: CreateJpClassAttendance): Promise<JpClassAttendanceStaff> {
    return this.api.createJpClassAttendanceStaff(source)
  }
  async createJpClassWlResultStaff(source: CreateJpClassWlResult): Promise<JpClassWlResultStaff> {
    return this.api.createJpClassWlResultStaff(source)
  }
  async updateJpClassTypeStaff(source: UpdateJpClassType): Promise<JpClassTypeStaff> {
    return this.api.updateJpClassTypeStaff(source)
  }
  async updateJpClassTypeOverrideStaff(source: UpdateJpClassTypeOverride): Promise<JpClassTypeOverrideStaff> {
    return this.api.updateJpClassTypeOverrideStaff(source)
  }
  async updateJpClassStaff(source: UpdateJpClass): Promise<JpClassStaff> {
    return this.api.updateJpClassStaff(source)
  }
  async updateJpClassSessionStaff(source: UpdateJpClassSession): Promise<JpClassSessionStaff> {
    return this.api.updateJpClassSessionStaff(source)
  }
  async updateJpClassStaggerStaff(source: UpdateJpClassStagger): Promise<JpClassStaggerStaff> {
    return this.api.updateJpClassStaggerStaff(source)
  }
  async updateJpClassSignupStaff(source: UpdateJpClassSignup): Promise<JpClassSignupStaff> {
    return this.api.updateJpClassSignupStaff(source)
  }
  async updateJpClassAttendanceStaff(source: UpdateJpClassAttendance): Promise<JpClassAttendanceStaff> {
    return this.api.updateJpClassAttendanceStaff(source)
  }
  async updateJpClassWlResultStaff(source: UpdateJpClassWlResult): Promise<JpClassWlResultStaff> {
    return this.api.updateJpClassWlResultStaff(source)
  }
  async deleteJpClassTypeStaff(source: DeleteJpClassTypeStaff): Promise<void> {
    return this.api.deleteJpClassTypeStaff(source)
  }
  async deleteJpClassTypeOverrideStaff(source: DeleteJpClassTypeOverrideStaff): Promise<void> {
    return this.api.deleteJpClassTypeOverrideStaff(source)
  }
  async deleteJpClassStaff(source: DeleteJpClassStaff): Promise<void> {
    return this.api.deleteJpClassStaff(source)
  }
  async deleteJpClassSessionStaff(source: DeleteJpClassSessionStaff): Promise<void> {
    return this.api.deleteJpClassSessionStaff(source)
  }
  async deleteJpClassStaggerStaff(source: DeleteJpClassStaggerStaff): Promise<void> {
    return this.api.deleteJpClassStaggerStaff(source)
  }
  async deleteJpClassSignupStaff(source: DeleteJpClassSignupStaff): Promise<void> {
    return this.api.deleteJpClassSignupStaff(source)
  }
  async deleteJpClassAttendanceStaff(source: DeleteJpClassAttendanceStaff): Promise<void> {
    return this.api.deleteJpClassAttendanceStaff(source)
  }
  async deleteJpClassWlResultStaff(source: DeleteJpClassWlResultStaff): Promise<void> {
    return this.api.deleteJpClassWlResultStaff(source)
  }
  async searchJpClassTypeStaff(params: JpClassTypeSearchParams, page: number, perPage: number): Promise<PaginationResult<JpClassTypeStaffSearchResult>> {
    return this.api.searchJpClassTypeStaff(params, page, perPage)
  }
  async searchJpClassStaff(params: JpClassSearchParams, page: number, perPage: number): Promise<PaginationResult<JpClassStaffSearchResult>> {
    return this.api.searchJpClassStaff(params, page, perPage)
  }
  async searchJpClassTypeStaffFull(params: JpClassTypeSearchParams, page: number, perPage: number, options?: JpClassTypeFetchOptions): Promise<PaginationResult<JpClassTypeStaff>> {
    return this.api.searchJpClassTypeStaffFull(params, page, perPage, options)
  }
  async searchJpClassStaffFull(params: JpClassSearchParams, page: number, perPage: number, options?: JpClassFetchOptions): Promise<PaginationResult<JpClassStaff>> {
    return this.api.searchJpClassStaffFull(params, page, perPage, options)
  }
  async getJpClassTypeStaffRatingPrereqId(id: number, options?: RatingFetchOptions): Promise<RatingStaff | null> {
    return this.api.getJpClassTypeStaffRatingPrereqId(id, options)
  }
  async getJpClassTypeStaffRatingOverkillId(id: number, options?: RatingFetchOptions): Promise<RatingStaff | null> {
    return this.api.getJpClassTypeStaffRatingOverkillId(id, options)
  }
  async getJpClassTypeStaffClassPrereqId(id: number, options?: JpClassTypeFetchOptions): Promise<JpClassTypeStaff | null> {
    return this.api.getJpClassTypeStaffClassPrereqId(id, options)
  }
  async getJpClassTypeStaffClassOverkillId(id: number, options?: JpClassTypeFetchOptions): Promise<JpClassTypeStaff | null> {
    return this.api.getJpClassTypeStaffClassOverkillId(id, options)
  }
  async getJpClassTypeStaffTeachRatingId(id: number, options?: RatingFetchOptions): Promise<RatingStaff | null> {
    return this.api.getJpClassTypeStaffTeachRatingId(id, options)
  }
  async getJpClassTypeStaffClasses(id: number, options?: JpClassFetchOptions): Promise<Array<JpClassStaff>> {
    return this.api.getJpClassTypeStaffClasses(id, options)
  }
  async getJpClassTypeStaffTypesRequiringThisAsPrereq(id: number, options?: JpClassTypeFetchOptions): Promise<Array<JpClassTypeStaff>> {
    return this.api.getJpClassTypeStaffTypesRequiringThisAsPrereq(id, options)
  }
  async getJpClassTypeStaffTypesRequiringThisAsOverkill(id: number, options?: JpClassTypeFetchOptions): Promise<Array<JpClassTypeStaff>> {
    return this.api.getJpClassTypeStaffTypesRequiringThisAsOverkill(id, options)
  }
  async getJpClassTypeStaffOverrides(id: number, options?: JpClassTypeOverrideFetchOptions): Promise<Array<JpClassTypeOverrideStaff>> {
    return this.api.getJpClassTypeStaffOverrides(id, options)
  }
  async getJpClassTypeOverrideStaffPersonId(id: number, options?: PersonFetchOptions): Promise<PersonStaff> {
    return this.api.getJpClassTypeOverrideStaffPersonId(id, options)
  }
  async getJpClassTypeOverrideStaffTypeId(id: number, options?: JpClassTypeFetchOptions): Promise<JpClassTypeStaff> {
    return this.api.getJpClassTypeOverrideStaffTypeId(id, options)
  }
  async getJpClassStaffTypeId(id: number, options?: JpClassTypeFetchOptions): Promise<JpClassTypeStaff> {
    return this.api.getJpClassStaffTypeId(id, options)
  }
  async getJpClassStaffLocationId(id: number, options?: ClassLocationFetchOptions): Promise<ClassLocationStaff | null> {
    return this.api.getJpClassStaffLocationId(id, options)
  }
  async getJpClassStaffInstructorId(id: number, options?: PersonFetchOptions): Promise<PersonStaff | null> {
    return this.api.getJpClassStaffInstructorId(id, options)
  }
  async getJpClassStaffSessions(id: number, options?: JpClassSessionFetchOptions): Promise<Array<JpClassSessionStaff>> {
    return this.api.getJpClassStaffSessions(id, options)
  }
  async getJpClassStaffSignups(id: number, options?: JpClassSignupFetchOptions): Promise<Array<JpClassSignupStaff>> {
    return this.api.getJpClassStaffSignups(id, options)
  }
  async getJpClassStaffStaggers(id: number, options?: JpClassStaggerFetchOptions): Promise<Array<JpClassStaggerStaff>> {
    return this.api.getJpClassStaffStaggers(id, options)
  }
  async getJpClassSessionStaffInstanceId(id: number, options?: JpClassFetchOptions): Promise<JpClassStaff> {
    return this.api.getJpClassSessionStaffInstanceId(id, options)
  }
  async getJpClassSessionStaffAttendance(id: number, options?: JpClassAttendanceFetchOptions): Promise<Array<JpClassAttendanceStaff>> {
    return this.api.getJpClassSessionStaffAttendance(id, options)
  }
  async getJpClassStaggerStaffInstanceId(id: number, options?: JpClassFetchOptions): Promise<JpClassStaff> {
    return this.api.getJpClassStaggerStaffInstanceId(id, options)
  }
  async getJpClassSignupStaffWlResult(id: number, options?: JpClassWlResultFetchOptions): Promise<JpClassWlResultStaff | null> {
    return this.api.getJpClassSignupStaffWlResult(id, options)
  }
  async getJpClassSignupStaffInstanceId(id: number, options?: JpClassFetchOptions): Promise<JpClassStaff> {
    return this.api.getJpClassSignupStaffInstanceId(id, options)
  }
  async getJpClassSignupStaffPersonId(id: number, options?: PersonFetchOptions): Promise<PersonStaff> {
    return this.api.getJpClassSignupStaffPersonId(id, options)
  }
  async getJpClassSignupStaffAttendance(id: number, options?: JpClassAttendanceFetchOptions): Promise<Array<JpClassAttendanceStaff>> {
    return this.api.getJpClassSignupStaffAttendance(id, options)
  }
  async getJpClassAttendanceStaffSessionId(id: number, options?: JpClassSessionFetchOptions): Promise<JpClassSessionStaff> {
    return this.api.getJpClassAttendanceStaffSessionId(id, options)
  }
  async getJpClassAttendanceStaffSignupId(id: number, options?: JpClassSignupFetchOptions): Promise<JpClassSignupStaff> {
    return this.api.getJpClassAttendanceStaffSignupId(id, options)
  }
  async getJpClassWlResultStaffSignupId(id: number, options?: JpClassSignupFetchOptions): Promise<JpClassSignupStaff> {
    return this.api.getJpClassWlResultStaffSignupId(id, options)
  }
  async getClassInstanceStaff(ref: JpClassRef): Promise<JpClassStaff> {
    return this.api.getClassInstanceStaff(ref)
  }
  async getClassInstanceMember(ref: JpClassRef): Promise<JpClassMember> {
    return this.api.getClassInstanceMember(ref)
  }
  async summaryLabelStaff(target: JpClassRef): Promise<string> {
    return this.api.summaryLabelStaff(target)
  }
  async summaryLabelMember(target: JpClassRef): Promise<string> {
    return this.api.summaryLabelMember(target)
  }
}
